import { useEffect } from "react";

interface SeoOptions {
  title: string;
  description: string;
  keywords?: string;
}

const ensureMeta = (name: string) => {
  let tag = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("name", name);
    document.head.appendChild(tag);
  }
  return tag;
};

/**
 * 设置页面独立 TDK（标题 / description / keywords），基于原生 DOM 操作，
 * 不引入额外依赖，随组件挂载与参数变化更新。
 */
export const useSeo = ({ title, description, keywords }: SeoOptions) => {
  useEffect(() => {
    document.title = title;
    ensureMeta("description").setAttribute("content", description);
    if (keywords) {
      ensureMeta("keywords").setAttribute("content", keywords);
    }
  }, [title, description, keywords]);
};